import { Card } from "react-bootstrap";
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router-dom";
import { Button } from "./components/Button";
import { CenteredPage } from "./components/CenteredPage";

export function ErrorPage() {
    const nav   = useNavigate();
    const error = useRouteError();
    let message: string;
    if( isRouteErrorResponse( error ) ) {
        message = error.status === 404
            ? "The requested page could not be found."
            : error.data?.toString() ?? "An unexpected error has occurred.";
    } else {
        message = ( error as Error ).message;
    }
    return <div className="vh-100 d-flex align-items-center justify-content-center">
        <CenteredPage sm="10" md="8" lg="6" xl="4" style={{ maxWidth: "33em" }}>
            <Card className="w-100 shadow">
                <Card.Header className="h5 fw-bold">
                    Error
                </Card.Header>
                <Card.Body className="p-4 pt-3">
                    <div className="d-grid gap-4 mb-3">
                        <div className="d-flex flex-column justify-content-center">
                            <div className="text-muted">
                                {message}
                            </div>
                            <div className="text-muted">
                                Please try again or return to the homepage.
                            </div>
                        </div>
                    </div>
                    <div className="d-flex gap-2">
                        <Button variant="secondary" className="w-100" onClick={() => nav( -1 )}>
                            Go Back
                        </Button>
                        <Button className="w-100" onClick={() => nav( "/" )}>
                            Go Home
                        </Button>
                    </div>
                </Card.Body>
            </Card>
        </CenteredPage>
    </div>;
}